import * as React from "react";
import { FieldWithLabelContainer, Label } from "./Label.style";
import type { WithLabelParams, WithLabelProps } from "./Label.interface";

export const withLabel = <P extends { id?: string; disabled?: boolean }, Ref extends HTMLElement>(
    Component: React.ComponentType<P>,
    params?: WithLabelParams,
) => {
    const newComponent = React.forwardRef<Ref, P & WithLabelProps>((props, ref) => {
        const { label, disabled, id, ...rest } = props;
        const { orientation = "horizontal" } = params ?? {};

        const uniqId = React.useId();
        if (!label) {
            return <Component ref={ref} id={id} disabled={disabled} {...(rest as P)} />;
        }

        return (
            <FieldWithLabelContainer data-orientation={orientation} disabled={disabled}>
                <Label data-testid="svy-label" htmlFor={id ?? uniqId}>
                    {label}
                </Label>
                <Component ref={ref} id={id ?? uniqId} disabled={disabled} {...(rest as P)} />
            </FieldWithLabelContainer>
        );
    });
    newComponent.displayName = Component.displayName;
    return newComponent;
};
